import styled from 'styled-components'
import { NavLink} from 'react-router-dom'


export const Container = styled.div`
display: flex;
background: #F9F9F9;
padding: 20px 200px;
`

export const NavbarLink = styled(NavLink)`
text-decoration: none;
font-family: Poppins;
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 22px;
margin-right: 40px;
color: #151515;
white-space: nowrap;
`